@if (showAction()) {
  <mat-accordion class="tw-w-full">
    <mat-expansion-panel class="mid-call-disposition-panel" data-cy="mid-call-disposition">
      <mat-expansion-panel-header class="mid-call-disposition-header">
        <mat-panel-title>Disposition</mat-panel-title>
      </mat-expansion-panel-header>

      @if (!wrapUpOption) {
        <h4>What happened?</h4>

        <mat-form-field class="tw-w-full" (click)="$event.stopPropagation()">
          <mat-label>Select Outcome</mat-label>
          <mat-select
            data-cy="mid-call-disposition-select"
            panelClass="wrapUpSelect"
            [value]="selectedOption"
            (selectionChange)="handleSelection($event.value)">
            @for (option of visibleOptions; track option) {
              <mat-option [value]="option">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        @if (selectedOption) {
          <div data-cy="whats-next" class="whats-next">
            @if (activeCall?.borrowerId) {
              <h4>What's next?</h4>
            }
            <div class="whats-next-grid">
              @if (nextStepBtnDisplay(false)) {
                <button
                  mat-stroked-button
                  color="secondary"
                  class="wrapUpBtn"
                  data-cy="schedule-reminder"
                  (click)="wrapUpOption = 'reminder'">
                  <div class="wrapUp-BtnText">
                    <p>Schedule Reminder</p>
                    <span class="fa fa-check wrapUp-check" [ngClass]="reminderSet ? 'green-check' : 'pre-check'"></span>
                  </div>
                </button>
              }
              @if (nextStepBtnDisplay(false)) {
                <button
                  mat-stroked-button
                  color="secondary"
                  class="wrapUpBtn"
                  data-cy="add-note"
                  (click)="wrapUpOption = 'notes'">
                  <div class="wrapUp-BtnText">
                    <p>Add Note</p>
                    <span class="fa fa-check wrapUp-check" [ngClass]="noteLeft ? 'green-check' : 'pre-check'"></span>
                  </div>
                </button>
              }
              @if (nextStepBtnDisplay(true)) {
                <button
                  mat-stroked-button
                  color="secondary"
                  class="wrapUpBtn"
                  data-cy="send-text"
                  (click)="wrapUpOption = 'sms'">
                  <div class="wrapUp-BtnText">
                    <p>Send Text</p>
                    <span class="fa fa-check wrapUp-check" [ngClass]="smsSent ? 'green-check' : 'pre-check'"></span>
                  </div>
                </button>
              }
              @if (nextStepBtnDisplay(true)) {
                <button
                  mat-stroked-button
                  color="secondary"
                  class="wrapUpBtn"
                  data-cy="send-email"
                  (click)="wrapUpOption = 'email'">
                  <div class="wrapUp-BtnText">
                    <p>Send Email</p>
                    <span class="fa fa-check wrapUp-check" [ngClass]="emailSent ? 'green-check' : 'pre-check'"></span>
                  </div>
                </button>
              }
            </div>
          </div>
        }

        @if (selectedOption) {
          <button
            mat-flat-button
            color="primary"
            class="tw-w-full tw-mt-3"
            data-cy="mid-call-disposition-save"
            (click)="saveDisposition()">
            Save Disposition
          </button>
        }
      }

      <div class="close-modal">
        @if (wrapUpOption && allowCloseWrapUpOption) {
          <span (click)="closeWrapUpOption()" class="fa fa-arrow-left close-modal-btn"></span>
        }
      </div>

      @switch (wrapUpOption) {
        @case ('reminder') {
          <div class="reminder">
            <app-schedule-reminder-smart
              [view]="'borrower'"
              [borrowerId]="borrowerId"
              (closeMenu)="closeWrapUpOption()">
            </app-schedule-reminder-smart>
          </div>
        }
        @case ('notes') {
          <div class="notes">
            <app-notes-smart
              [borrowerId]="borrowerId"
              [addNoteOpen]="true"
              [expanded]="true"
              (noteAdded)="closeWrapUpOption()">
            </app-notes-smart>
          </div>
        }
        @case ('sms') {
          <div class="sms">
            <app-sms-smart [borrower]="$any(borrower)"></app-sms-smart>
          </div>
        }
        @case ('email') {
          <div class="email ls1">
            @if ((alert$ | async); as alert) {
              <app-alert
                [level]="alert.level"
                [message]="alert.message"
                (dismissed)="handleAlertDismissed()">
              </app-alert>
            }
            <app-messages-create
              [borrower]="$any(borrower)"
              [user]="borrowerUserName"
              (emailCreate)="handleEmailCreate($any($event))"
              (cancelMessage)="closeWrapUpOption()">
            </app-messages-create>
          </div>
        }
      }
    </mat-expansion-panel>
  </mat-accordion>
}
